import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Component, OnInit } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";

@Component({
  selector: "app-feature-slide-show",
  templateUrl: "./feature-slide-show.component.html",
  styleUrls: ["./feature-slide-show.component.scss"],
  animations: [
    trigger("openClose", [
      state(
        "1",
        style({
          opacity: 1,
        })
      ),
      state(
        "0",
        style({
          opacity: 0,
        })
      ),
      transition("* => 1", [animate("0.7s")]),
      transition("* => 0", [animate("0.35s")]),
    ]),
  ],
})
export class FeatureSlideShowComponent implements OnInit {
  currentImageIndex: number = 0;
  rightIndex: number = 0;
  images: string[] = [
    "/assets/crowd.png",
    "/assets/happy.png",
    "/assets/computer-guy.png",
  ];
  heading: string[] = ["heading1", "heading2", "heading3"];
  text: string[] = ["card1", "card2", "card3"];
  title: string[] = ["title1", "title2", "title3"];

  slides: number[] = [0, 1, 2];

  leftImage = true;

  constructor(public translateService: TranslocoService) {}

  ngOnInit(): void {
    console.log(this.translateService.getActiveLang());
  }

  next() {
    this.leftImage = false;
    this.currentImageIndex =
      this.currentImageIndex === 2
        ? 0
        : this.slides[this.currentImageIndex + 1];
    setTimeout(() => {
      this.rightIndex = this.currentImageIndex;
      setTimeout(() => {
        this.leftImage = !this.leftImage;
      }, 300);
    }, 350);
  }
  previous() {
    this.leftImage = false;
    this.currentImageIndex =
      this.currentImageIndex === 0
        ? 2
        : this.slides[this.currentImageIndex - 1];
    setTimeout(() => {
      this.rightIndex = this.currentImageIndex;
      setTimeout(() => {
        this.leftImage = !this.leftImage;
      }, 300);
    }, 350);
  }

  navigateTo(n: number) {
    this.currentImageIndex = n;
    this.leftImage = false;
    setTimeout(() => {
      this.rightIndex = this.currentImageIndex;
      setTimeout(() => {
        this.leftImage = !this.leftImage;
      }, 300);
    }, 350);
  }
}
